export default __webpack_public_path__ + "static/media/points_all.5c6ce7e3.png";